import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core";
import { withSnackbar } from 'notistack';
import DataGrid from "../../../../dataGrid"
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import GridConfig from "./gridConfig";
import styles from "../../styles";
import { compose } from "recompose";
import { getDataWithQueryString, postData } from "../../../../../api/componentAPIs";
import { isTimeValid } from "../../../../dataGrid/gridUtilities";
import MESSAGES from "../../../../../appMessages";

class DriverPreferences extends React.PureComponent{
    constructor(props){
        super(props);
        this.gridConfig = new GridConfig();
        this.state = {
            driverData: null,
            errorMessage: null
        }
    }

    componentDidMount(){
        this.getDriverPreferenceData();
    }

    componentDidUpdate(prevProps){
        if( this.props.userData.userProfile.scenarioID !== prevProps.userData.userProfile.scenarioID){
            this.getDriverPreferenceData();
        }     
    }

    getDriverPreferenceData = () => {
        const  { scenarioID } =  this.props.userData.userProfile;
        
        getDataWithQueryString("GetDriverPreferences",`scenarioId=${scenarioID}`).then( response => {
            if(response.status === 200){
                this.setState({
                    driverData: response.data,
                    errorMessage: null
                });
            } else {
                this.setState({
                    driverData: null,
                    errorMessage: MESSAGES.DRIVER_PREF.FETCH_DATA_FAILURE
                });
            }
        }, error => {
            this.setState({
                driverData: null,
                errorMessage: MESSAGES.DRIVER_PREF.FETCH_DATA_FAILURE
            });
        });
    }


    updateDriverPreferences = (params) => {
        const updateObject = {
            scenarioId: this.props.userData.userProfile.scenarioID,
            driverPreference:{
                ...params.data,
                [params.colDef.field]: params.newValue
            }
        }
        postData("UpdateDriverPreferences", updateObject).then(response => {
            if(Math.trunc(response.status/100) === 2){
                this.props.enqueueSnackbar(`${params.colDef.headerName} updated for zone ${params.data.preferredZone}`, {variant: "success"});
            } else {
               this.handleUpdateFailure(params);
            }
        },error =>{
            this.handleUpdateFailure(params);
        });
    }

    handleUpdateFailure = (params, message) => {
        message = message || `Failed to update ${params.colDef.headerName} for zone ${params.data.preferredZone}`;
        this.props.enqueueSnackbar(message, {variant: "error"});
        params.data[params.colDef.field] = params.oldValue;
        this.gridApi.refreshCells();
    }

    onCellValueChanged = (params) =>{
        if(params.colDef.field === "startTime") {
            if(params.oldValue !== params.newValue){
                if(!params.newValue){
                    this.handleUpdateFailure(params,MESSAGES.DRIVER_PREF.STARTTIME_EMPTY);
                } else if(!isTimeValid(params.newValue)) {
                    this.handleUpdateFailure(params, MESSAGES.DRIVER_PREF.STARTTIME_INVALID);
                } else {
                    this.updateDriverPreferences(params);
                }              
            }
        }
    }

    onGridReady = ({api}) => {
        this.gridApi = api;
    }

    render(){
        const { classes } = this.props;
        const { driverData } = this.state;
        return(
            <Fragment>
                <header className={classes.moduleHeader}  data-automationid="driverPreferences-title"> Driver Preferences </header>
                <div className={classes.moduleContainer}>
                    <div className={`${classes.gridContainer} ${classes.parameterGridContainer}`}>
                        <div className={`${classes.dataGrid} ${classes.parameterGrid}`}>
                        {!this.state.errorMessage ? (
                            <DataGrid
                                columnDefs={this.gridConfig.config.columns}
                                config={this.gridConfig.config}
                                enableFilter={this.gridConfig.config.enableFilter}
                                enableSorting={this.gridConfig.config.enableSorting}
                                rowData={driverData}
                                onGridReady={this.onGridReady}
                                onCellValueChanged={this.onCellValueChanged}
                            />
                            ): (
                                <div className={classes.errorMessageContainer}>
                                        <div className={classes.errorMessage}> {this.state.errorMessage} </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
        </Fragment>

        )
    }
}

export default compose(withStyles(styles), withUserProfile, withSnackbar)(DriverPreferences)
